import { Dictionary } from '@reduxjs/toolkit';

export const toDictionary = <TItem>(
    items: TItem[],
    keySelector: (item: TItem) => string
) => {

    const result: Dictionary<TItem> = {};

    for (const item of items) {
        result[keySelector(item)] = item;
    }

    return result;
};

export const toList = <T>(dictionary: Dictionary<T>): T[] => {
    return Object.values(dictionary) as T[];
};